import { render } from "./MenteesPage.vue?vue&type=template&id=0c0beb42&scoped=true"
import script from "./MenteesPage.vue?vue&type=script&lang=js"
export * from "./MenteesPage.vue?vue&type=script&lang=js"

import "./MenteesPage.vue?vue&type=style&index=0&id=0c0beb42&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c0beb42"]])

export default __exports__